import { render, staticRenderFns } from "./ProductHeadFields.vue?vue&type=template&id=6c7a14c2&"
import script from "./ProductHeadFields.vue?vue&type=script&lang=js&"
export * from "./ProductHeadFields.vue?vue&type=script&lang=js&"
import style0 from "./ProductHeadFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports